var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "d-flex flex-column justify-center align-sm-center height-100x overflow-auto width-100",
    },
    [
      _c(
        "div",
        {
          staticClass: "height-100x py-10",
          staticStyle: { "max-width": "520px" },
        },
        [
          _vm._m(0),
          _c(
            "v-card",
            { staticClass: "mb-4", attrs: { flat: "" } },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("base-text-field", {
                            attrs: {
                              name: "newPassword",
                              label: "New Password",
                              type: _vm.showNewPassword ? "text" : "password",
                              "append-icon": _vm.showNewPassword
                                ? "mdi-eye"
                                : "mdi-eye-off",
                              value: _vm.newPassword,
                            },
                            on: {
                              "click:append": function ($event) {
                                _vm.showNewPassword = !_vm.showNewPassword
                              },
                              "update:value": function ($event) {
                                _vm.newPassword = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("base-text-field", {
                            attrs: {
                              name: "confirmNewPassword",
                              label: "Confirm New Password",
                              type: _vm.showConfirmPassword
                                ? "text"
                                : "password",
                              "append-icon": _vm.showConfirmPassword
                                ? "mdi-eye"
                                : "mdi-eye-off",
                              value: _vm.confirmNewPassword,
                            },
                            on: {
                              "click:append": function ($event) {
                                _vm.showConfirmPassword =
                                  !_vm.showConfirmPassword
                              },
                              "update:value": function ($event) {
                                _vm.confirmNewPassword = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "d-flex align-center justify-space-between",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "base-btn",
                            { attrs: { text: "" }, on: { click: _vm.goBack } },
                            [_vm._v("Back")]
                          ),
                          _c(
                            "base-btn",
                            {
                              attrs: { color: "rgb(115, 141, 202)" },
                              on: { click: _vm.updatePassword },
                            },
                            [_vm._v("Update password")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "text-center mb-6" }, [
      _c("h1", { staticClass: "mb-2" }, [_vm._v("Set new password")]),
      _c("div", { staticClass: "text-body-2" }, [
        _vm._v("Enter your new password to complete reset."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }